<template>
    <div class="items-day">
        <div class="item-day my-cursor"
             :class="[
                {'is-today': dayItem.isToday},
                {'is-click': dayItem.isClick},
                {'is-contain': dayItem.isContain},
                {'is-same': dayItem.sameMonth}
                ]"
             @click.stop="clickDay(dayItem)"
             v-for="dayItem in dayItems">
            <div class="icon-work" v-if="dayItem.isWork === 1"></div>
            <div class="icon-rest" v-if="dayItem.isWork === 2"></div>
            <div class="text-day">{{dayItem.day}}</div>
            <div class="text-lunar-day"
                 :class="{'text-lunar-color': dayItem.sameMonth && dayItem.viceColor}"
                 :style="{color: dayItem.isClick ?  '#FFFFFF': ''}">
                {{ dayItem.viceDay }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DateCross",
    data(){
        return {
            dayItems: [],
        }
    },
    props: {
        todayStr: {
            type: String,
            default: "",
        },
        startDate: {
            type: String,
            default: "",
        },
        endDate: {
            type: String,
            default: "",
        },

    },
    methods: {

        updateDayItems: function(solarMonth){
            let dayItems = this.$Utils.getMonthDays(solarMonth);
            const monthNum = solarMonth.getMonth();
            dayItems.forEach((item, index, array)=>{
                const itemYmd = item.toYmd();
                const isWork = this.$Utils.checkWork(itemYmd);
                const sameMonth = item.getMonth() === monthNum;
                const isToday = itemYmd === this.todayStr;
                const viceItem = this.$Utils.getViceDay(item);
                const isClick = itemYmd === this.startDate || itemYmd === this.endDate;
                const isContain = this.startDate !== "" && itemYmd > this.startDate && itemYmd < this.endDate;

                array[index] = {
                    day: item.getDay(),
                    viceDay: viceItem.viceDay,
                    viceColor: viceItem.viceColor,
                    isWork: isWork,
                    weekday: item.getWeekInChinese(),
                    sameMonth: sameMonth,
                    isToday: isToday,
                    isClick: isClick,
                    isContain: isContain,
                    date: item.toYmd(),
                }
            })
            this.dayItems = dayItems;

        },
        updSelectDate: function (startDate, endDate) {
            this.dayItems.forEach((item) => {
                if (startDate === item.date || endDate === item.date) {
                    item.isClick = true;
                    item.isContain = false;
                } else if (startDate !== "" && item.date > startDate && item.date < endDate) {
                    item.isClick = false;
                    item.isContain = true;
                } else {
                    item.isClick = false;
                    item.isContain = false;
                }
            })
        },
        clickDay: function(item){
            let startDate = "";
            let endDate = "";
            if(this.startDate !== "" && this.startDate === this.endDate){
                if(item.date > this.startDate){
                    startDate = this.startDate;
                    endDate = item.date;
                }else{
                    startDate = item.date;
                    endDate = this.startDate;
                }
                if(this.$Utils.getIntervalDays(endDate, startDate) + 1 > 365){
                    startDate = endDate = item.date;
                }
            }else{
                startDate = endDate = item.date;
            }
            this.updSelectDate(startDate, endDate);

            this.$emit("submitEvent", [startDate, endDate]);
        },
        clearDate: function(){
            this.dayItems.forEach((item)=>{
                item.isClick = false;
                item.isContain = false;
            })
        },
    },
}
</script>

<style scoped>
div.items-day{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    row-gap: 0.1rem;
    column-gap: 0.12rem;
    justify-content: center;
}
div.item-day{
    width: 0.42rem;
    height: 0.42rem;
    border-radius: 50%;
    border: 0.02rem solid transparent;
    box-sizing: border-box;
    position: relative;
}

div.icon-work, div.icon-rest{
    width: 0.1rem;
    height: 0.1rem;
    position: absolute;
    right: -0.06rem;
}
div.icon-work{
    background: url("../../../assets/images/List/icon-work.png");
    background-size: cover;
}
div.icon-rest{
    background: url("../../../assets/images/List/icon-rest.png");
    background-size: cover;
}
div.text-day{
    font-weight: bold;
    font-size: 0.16rem;
    color: rgba(0, 0, 0, 0.5);
    text-align: center;
    font-style: normal;
}
div.text-lunar-day{
    font-size:.12rem;
    transform:scale(.8);
    font-family: PF-Regular, sans-serif;
    color: rgba(0, 0, 0, 0.5);
    text-align: center;
}
div.is-same div.text-day, div.text-lunar-color{
    color: #000000;
}
div.is-today{
    border-style: dashed;
    border-color: #000000;
}
div.is-click{
    border-style: solid;
    border-color: #000000;
    background-color: #000000;
}
div.is-click div.text-day{
    color: #FFFFFF;
}
div.is-click > div.text-lunar-day{
    color: #FFFFFF;
}
div.is-contain{
    background: rgba(254, 228, 148, 0.5);
}
</style>